import { render, staticRenderFns } from "./RemoveContactWindow.vue?vue&type=template&id=3d46e18e&"
import script from "./RemoveContactWindow.vue?vue&type=script&lang=js&"
export * from "./RemoveContactWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports